export default "__VITE_ASSET__DAO9hFBD__"